import React from "react";

interface UploaderProps {
  label: string;
  name: string;
  accept: string;
  multiple?: boolean;
  previews: string[];
  previewType?: "image" | "video";
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDelete?: (index: number) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;   // ✅ Delete handler
  required?: boolean;
}

const Uploader: React.FC<UploaderProps> = ({
  label,
  name,
  accept,
  multiple,
  previews,
  previewType,
  onChange,
  onDelete,
  inputRef,
  required = false,
}) => {
  return (
    <div className="box-fieldset">
      <label htmlFor={name}>{label}
        {required && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>} {/* Add the asterisk here */}
      </label>
      <input
        ref={inputRef}
        className="form-control"
        type="file"
        name={name}
        accept={accept}
        multiple={multiple}
        onChange={onChange}
      />

      {previews?.length > 0 && (
        <div className="mt-2">
          {previews.map((url, idx) => (
            <div  key={idx} style={{width: "30%", position: "relative", marginBottom: "8px", float: "left", paddingRight: "8px" }}>
            <div>
              {previewType === "video" ? (
                <video
                  src={url}
                  controls
                  style={{width: "auto", maxHeight: "100px", borderRadius: "4px" }}
                />
              ) : (
                <img
                  src={url}
                  alt={`${name}-${idx}`}
                  style={{width: "auto", maxHeight: "100px", borderRadius: "4px" }}
                />
              )}

              {onDelete && (
                <button
                  type="button"
                  onClick={() => onDelete(idx)}
                  style={{
                    position: "absolute",
                    top: "4px",
                    right: "4px",
                    background: "red",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              )}
            </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Uploader;
